(() => {
  const root = document.querySelector('[data-v27-article]');
  if (!root) return;

  const content = root.querySelector('[data-v27-article-content]');
  const toc = root.querySelector('[data-v27-article-toc]');
  if (!content || !toc) return;

  const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => heading.textContent.trim());
  const block = toc.closest('[data-v27-article-toc-block]');
  if (!headings.length) {
    if (block) block.hidden = true;
    return;
  }

  const existingIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id));
  const makeSlug = (text) => text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'section';

  const fragment = document.createDocumentFragment();
  const linkMap = new Map();

  headings.forEach((heading, index) => {
    if (!heading.id) {
      const base = `article-${makeSlug(heading.textContent)}`;
      let candidate = base;
      let suffix = 2;
      while (existingIds.has(candidate)) {
        candidate = `${base}-${suffix}`;
        suffix += 1;
      }
      heading.id = candidate;
      existingIds.add(candidate);
    }

    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    link.dataset.level = heading.tagName === 'H3' ? '3' : '2';
    if (index === 0) {
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'true');
    }
    fragment.appendChild(link);
    linkMap.set(heading.id, link);
  });

  toc.replaceChildren(fragment);

  const setActive = (id) => {
    linkMap.forEach((link, linkId) => {
      const active = linkId === id;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };

  let ticking = false;
  const updateActive = () => {
    const marker = window.scrollY + Math.min(window.innerHeight * 0.3, 260);
    let current = headings[0];
    headings.forEach((heading) => {
      if (heading.getBoundingClientRect().top + window.scrollY <= marker) current = heading;
    });
    setActive(current.id);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateActive);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  updateActive();
})();
